import { gql } from '@apollo/client'

// query name added, will appear as getAsset in asset manager
export default gql(`
query getVirtualAsset($id: ID! $project: String $module: String) {
    getAsset(
            id: $id
            project: $project
            module: $module
        ) {
        id
        isInTransition
        isLive
        duration
        defaultVideo{
            id
        }
        vodJobs{
            id
            status
            site
            name
            type
            jobType
            vwmJobId
            updatedAt
            createdAt
            createdBy
            progress
            errorDesc
            startTime
            endTime 
            jobStates{
                status
                errorCode
                updatedAt
            }
            channel{
                id
            } 
            mediaId{
                id
                duration
            }  
        }
    }
}`)
